import { StrictMode } from 'react';
import { CarvanaTheme, ThemeProvider } from '@carvana/showroom-theme';
import { CarvanaTheme as OldTheme } from '@carvana/theme';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import QualiSurveyController from './components/QualiSurveyController';
import { QualiSurveyProps } from './types';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {}
});

const Main = (props: QualiSurveyProps) => (
  <StrictMode>
    <ThemeProvider theme={{ ...OldTheme, ...CarvanaTheme }}>
      <QueryClientProvider client={queryClient}>
        <QualiSurveyController {...props} />
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>
);

export default Main;
